import { AppState } from '../root-reducer';
import { InternalProjectTemplatesState } from './reducers';

export const selectIPTState = (state: AppState): InternalProjectTemplatesState => state.internalProjectTemplateReducer;
